module.exports = __webpack_public_path__ + "img/twbglhc_bg.f503314c.png";